<template lang="pug">
  Icon.icon(name="notification-lightning" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Ваш аккаунт будет заблокирован. Дней до блокировки: {{ item.info.daysToBlock }}
</template>

<script>
export default {
  name: 'NotificationLowBalance',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
